/* ============================================================
   CARRITO — componente autocontenido
   ============================================================
   Para sumarlo a una página nueva alcanza con UNA línea:

       <script src="js/cart.js"></script>

   No hay que copiar ningún marcado: el panel lo escribe este archivo. Se eligió así porque un
   carrito sin JS no sirve para nada — al revés del header y el footer, que están duplicados a mano
   en cada HTML justo para que se vean sin JS.

   ⚠️ Este archivo NO usa nada de js/app.js, aunque ahí ya existan abrirVentana/cerrarVentana y
   hagan casi lo mismo: son privadas de su IIFE y este componente tiene que poder levantarse solo
   el día de la implementación real. Se pagan ~15 líneas repetidas de manejo de foco y se gana que
   el archivo viaje entero. No es un descuido.

   Lo único que este archivo espera del HTML es el CONTRATO DE DATOS de cada producto:

       <li class="product"  (o .item)
           data-sku="best-cloud-pink"
           data-name="Ariana Grande Cloud Pink"
           data-price="71.25"                    ← número, sin $ y con punto
           data-img="assets/best-cloud-pink.webp">
         …
         <button data-cart-add>…</button>        ← el botón que agrega
       </li>

   Nunca lee el texto de la tarjeta. Hoy esos atributos están escritos a mano; el día que haya
   backend los llena la plantilla (Liquid, React, lo que sea) y este archivo no se toca.

   Y el icono del carrito del header sólo necesita:  <button data-cart-open>
   El contador se lo inyecta este archivo, para no escribirlo en cada página.

   Su CSS es el bloque "Carrito (componente)" de css/styles.css: si te llevás este archivo,
   llevate ese bloque también.
   ============================================================ */
if (!window.__cacheCart) {
  window.__cacheCart = true;

(function () {

  /* ---------- 1) CONFIG ---------- */
  const CONFIG = {
    clave: 'cache-carrito',          /* nombre de la entrada en localStorage */
    vueloMs: 500,                    /* ← duración del vuelo al carrito: menos = más rápido */
    maxQty: 999,                     /* ← tope por línea. Era 99 y no alcanzaba para pedir 100 */
    moneda: '$',
    tiendaUrl: '/collections/all',   /* NUEVO-006: era 'shop.html' (prototipo estático) y daba 404 */
    textos: {
      titulo: 'Your cart',
      vacio: 'Your cart is empty.',
      vacioCta: 'Browse perfumes',
      subtotal: 'Subtotal',
      pagar: 'Checkout',
      seguir: 'Continue shopping',
      nota: 'Checkout is not connected yet — this is a preview.',
      quitar: 'Remove',
      cerrar: 'Close cart',
      agregado: 'Added',
      vaciar: 'Empty cart',
      vaciarOk: 'Tap again to confirm'
    }
  };

  const precio = n => CONFIG.moneda + n.toFixed(2);

  /* ---------- 2) ESTADO — la única frontera con la persistencia ----------
     Hoy es localStorage. Cuando el carrito sea de verdad, se reemplazan ESTAS DOS FUNCIONES por
     las llamadas a la API (un GET y un POST) y el resto del archivo sigue igual. Es el único
     lugar del componente que sabe dónde viven los datos. */
  let lineas = [];

  /* ⚠️ EN SHOPIFY el estado real vive en el servidor, no acá.
     `lineas` sigue siendo el espejo local (es lo que pinta el panel, y lo que hace que todo
     el resto del archivo pueda seguir siendo síncrono), pero cada cambio se ESCRIBE DETRÁS
     a /cart/update.js, que recibe cantidades ABSOLUTAS por variante — que es exactamente la
     forma que ya tiene el estado local, así que no hay que traducir nada.

     Un `sku` es el ID NUMÉRICO de la variante. Los que no son numéricos (los 8 perfumes del
     hero, mientras sigan siendo placeholders sin producto asociado) NO viajan al servidor:
     viven sólo en el localStorage, para poder seguir mostrando la maqueta sin ensuciar el
     carrito real.

     Fuera de Shopify (el archivo suelto, un preview local) no existe window.Shopify y todo
     vuelve a ser localStorage, igual que antes. */
  const EN_SHOPIFY = !!(window.Shopify && window.Shopify.routes);
  const RAIZ = EN_SHOPIFY ? (window.Shopify.routes.root || '/') : '/';
  const esVariante = sku => /^\d+$/.test(String(sku));

  function leerLocal() {
    try {
      const crudo = localStorage.getItem(CONFIG.clave);
      const datos = crudo ? JSON.parse(crudo) : [];
      /* Se filtra lo que no tenga forma de línea: si alguien editó el localStorage a mano o
         cambió el formato entre versiones, el carrito no se rompe, se vacía. */
      return Array.isArray(datos)
        ? datos.filter(l => l && l.sku && Number.isFinite(+l.price) && +l.qty > 0)
        : [];
    } catch (e) {
      return [];                     /* modo incógnito o storage lleno: el carrito vive en memoria */
    }
  }

  function guardarLocal(cuales) {
    try {
      localStorage.setItem(CONFIG.clave, JSON.stringify(cuales));
    } catch (e) { /* sin storage el carrito sigue funcionando, sólo no sobrevive a la recarga */ }
  }

  function leer() {
    /* Sólo el arranque síncrono. En Shopify, sincronizar() lo corrige enseguida con lo que
       diga el servidor, que es la verdad. */
    return EN_SHOPIFY ? leerLocal().filter(l => !esVariante(l.sku)) : leerLocal();
  }

  /* Las variantes que el servidor tenía la última vez. Hacen falta para mandar un 0 por las
     que se quitaron: /cart/update.js sólo toca las claves que recibe. */
  let remotas = [];

  function guardar() {
    if (!EN_SHOPIFY) { guardarLocal(lineas); return; }
    guardarLocal(lineas.filter(l => !esVariante(l.sku)));

    const updates = {};
    remotas.forEach(id => { updates[id] = 0; });
    lineas.forEach(l => { if (esVariante(l.sku)) updates[l.sku] = l.qty; });
    remotas = lineas.filter(l => esVariante(l.sku)).map(l => l.sku);

    if (!Object.keys(updates).length) return;
    fetch(RAIZ + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates })
    })
      .then(r => r.json())
      .then(adoptar)
      .catch(() => { /* sin red el panel ya muestra lo correcto; se reintenta al próximo cambio */ });
  }

  /* Toma lo que devolvió Shopify y lo vuelve el espejo local. ⚠️ Los precios de la API vienen
     en CENTAVOS; el resto del archivo trabaja en unidades. */
  function adoptar(carro) {
    if (!carro || !Array.isArray(carro.items)) return;
    const propias = lineas.filter(l => !esVariante(l.sku));
    lineas = carro.items.map(i => ({
      sku:   String(i.variant_id),
      name:  (!i.variant_title || i.variant_title === 'Default Title')
               ? i.product_title
               : i.product_title + ' · ' + i.variant_title,
      price: i.final_price / 100,
      img:   i.image || '',
      qty:   i.quantity
    })).concat(propias);
    remotas = lineas.filter(l => esVariante(l.sku)).map(l => l.sku);
    pintar();
  }

  function sincronizar() {
    if (!EN_SHOPIFY) return;
    fetch(RAIZ + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(adoptar)
      .catch(() => {});
  }

  /* ---------- 3) API pública ----------
     Es lo que cualquier página (o la implementación futura) puede llamar sin conocer el interior. */
  const API = {
    add(item, qty) {
      const n = Math.max(1, parseInt(qty, 10) || 1);
      const ya = lineas.find(l => l.sku === item.sku);
      if (ya) ya.qty = Math.min(CONFIG.maxQty, ya.qty + n);   /* mismo sku = suma, no línea nueva */
      else lineas.push({ sku: item.sku, name: item.name, price: +item.price, img: item.img, qty: n });
      guardar();
      pintar();
      return API.count();
    },
    setQty(sku, n) {
      const linea = lineas.find(l => l.sku === sku);
      if (!linea) return;
      const q = parseInt(n, 10) || 0;
      if (q <= 0) return API.remove(sku);   /* bajar de 1 quita la línea */
      linea.qty = Math.min(CONFIG.maxQty, q);
      guardar();
      refrescarNumeros();      /* ← y NO pintar(): ver el comentario de refrescarNumeros() */
    },
    remove(sku) {
      lineas = lineas.filter(l => l.sku !== sku);
      guardar();
      pintar();
    },
    clear() { lineas = []; guardar(); pintar(); },
    count() { return lineas.reduce((t, l) => t + l.qty, 0); },
    total() { return lineas.reduce((t, l) => t + l.price * l.qty, 0); },
    items() { return lineas.map(l => Object.assign({}, l)); },   /* copia: nadie muta el estado */
    open: abrir,
    close: cerrar
  };
  window.CacheCart = API;

  /* ---------- 4) PLANTILLA — el panel, inyectado una sola vez ---------- */
  const T = CONFIG.textos;
  const panel = document.createElement('div');
  panel.className = 'cart';
  panel.id = 'cart';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-modal', 'true');
  panel.setAttribute('aria-label', T.titulo);
  panel.hidden = true;
  panel.innerHTML = `
    <div class="cart__backdrop" data-cart-close></div>

    <aside class="cart__panel">
      <header class="cart__head">
        <h2 class="cart__title">${T.titulo} <span class="cart__n" data-cart-total-items>0</span></h2>
        <button class="cart__close" type="button" data-cart-close aria-label="${T.cerrar}"></button>
      </header>

      <ul class="cart__list" data-cart-list></ul>

      <p class="cart__empty" data-cart-empty>
        ${T.vacio}
        <a class="cart__emptycta" href="${CONFIG.tiendaUrl}">${T.vacioCta}</a>
      </p>

      <div class="cart__foot" data-cart-foot>
        <p class="cart__sum">
          <span>${T.subtotal}</span>
          <strong data-cart-total>${precio(0)}</strong>
        </p>
        ${EN_SHOPIFY
          ? `<a class="cart__pay" href="${RAIZ}checkout">${T.pagar}</a>`
          : `<button class="cart__pay" type="button" disabled>${T.pagar}</button>`}
        <p class="cart__nota">${EN_SHOPIFY ? "" : T.nota}</p>
        <p class="cart__acciones">
          <button class="cart__seguir" type="button" data-cart-close>${T.seguir}</button>
          <button class="cart__vaciar" type="button" data-cart-clear>${T.vaciar}</button>
        </p>
      </div>
    </aside>`;

  /* ---------- 4b) EL CARRITO FLOTANTE ----------
     El header NO es fijo, así que al bajar el icono se va de pantalla. Antes el producto volaba a
     una esquina vacía y por eso el vuelo "se desvanecía": no tenía a dónde llegar.
     Esta burbuja aparece justo cuando el icono del header sale de vista, así el vuelo SIEMPRE
     termina en algo que se ve. Lleva data-cart-open, así que hereda gratis el contador y el click
     que abre el panel. */
  const burbuja = document.createElement('button');
  burbuja.className = 'cart-fab';
  burbuja.type = 'button';
  burbuja.setAttribute('data-cart-open', '');
  burbuja.setAttribute('aria-label', T.titulo);
  burbuja.innerHTML = `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" aria-hidden="true">
      <path d="M4 7.5h16l-1.2 13H5.2L4 7.5Z"/>
      <path d="M8.6 7.5V6a3.4 3.4 0 0 1 6.8 0v1.5" stroke-linecap="round"/>
    </svg>`;

  /* ---------- 5) PINTAR ---------- */
  const $ = sel => panel.querySelector(sel);
  let lista, vacio, pie, totalTxt, itemsTxt;

  function pintar() {
    if (!lista) return;

    /* pintar() rehace la lista entera, así que si alguien está escribiendo en un campo de cantidad
       perdería el foco a la primera flecha. Se anota qué campo estaba activo y dónde tenía el
       cursor, y se restituye al final. */
    const activo = document.activeElement;
    const editando = activo && activo.classList && activo.classList.contains('cline__num')
      ? { sku: activo.closest('[data-sku]').dataset.sku, caret: activo.selectionStart }
      : null;

    lista.innerHTML = lineas.map(l => `
      <li class="cline" data-sku="${escapar(l.sku)}">
        <img class="cline__img" src="${escapar(l.img)}" alt="" width="120" height="120">
        <div class="cline__body">
          <p class="cline__name">${escapar(l.name)}</p>
          <p class="cline__unit">${precio(l.price)}</p>
          <div class="cline__qty">
            <button type="button" data-cart-step="-1" aria-label="One less ${escapar(l.name)}">&minus;</button>
            <input class="cline__num" type="text" inputmode="numeric" pattern="[0-9]*"
                   value="${l.qty}" aria-label="Quantity of ${escapar(l.name)}">
            <button type="button" data-cart-step="1" aria-label="One more ${escapar(l.name)}">+</button>
          </div>
        </div>
        <div class="cline__end">
          <button class="cline__del" type="button" data-cart-del aria-label="${T.quitar} ${escapar(l.name)}"></button>
          <p class="cline__sum">${precio(l.price * l.qty)}</p>
        </div>
      </li>`).join('');

    if (editando) {
      const campo = lista.querySelector(`[data-sku="${CSS.escape(editando.sku)}"] .cline__num`);
      if (campo) {
        campo.focus();
        const fin = campo.value.length;
        campo.setSelectionRange(Math.min(editando.caret, fin), Math.min(editando.caret, fin));
      }
    }

    const hay = lineas.length > 0;
    vacio.hidden = hay;
    pie.hidden = !hay;
    totalTxt.textContent = precio(API.total());
    itemsTxt.textContent = API.count();
    itemsTxt.hidden = !hay;                /* "Your cart 0" queda raro: la pastilla se esconde */

    pintarContador();
  }

  /* El contador del icono del header y de la burbuja */
  function pintarContador() {
    const n = API.count();
    document.querySelectorAll('[data-cart-open]').forEach(boton => {
      let punto = boton.querySelector('.cart-dot');
      if (!punto) {
        punto = document.createElement('span');
        punto.className = 'cart-dot';
        punto.setAttribute('aria-hidden', 'true');
        boton.appendChild(punto);
      }
      punto.textContent = n;
      punto.hidden = n === 0;
      /* El nombre accesible dice cuántos hay, que el número visual no lo lee nadie */
      boton.setAttribute('aria-label', n ? `Cart, ${n} item${n === 1 ? '' : 's'}` : 'Cart');
    });
  }

  /* Actualiza SÓLO los números, sin rehacer la lista.
     ⚠️ Esto no es una optimización, es una corrección. Cuando cambiar una cantidad repintaba la
     lista entera pasaba lo siguiente: el repintado quitaba del DOM el campo que tenía el foco, eso
     disparaba su `focusout` con el valor VIEJO, y el manejador de focusout lo volvía a guardar
     deshaciendo el cambio. Resultado: apretabas ↓ y el estado se quedaba un paso atrás del campo.
     Sin repintar no hay blur, no hay focusout fantasma y el foco no se mueve. */
  function refrescarNumeros() {
    if (!lista) return;
    lineas.forEach(l => {
      const li = lista.querySelector(`[data-sku="${CSS.escape(l.sku)}"]`);
      if (!li) return;
      const campo = li.querySelector('.cline__num');
      if (campo) campo.value = l.qty;      /* poner .value no mueve el foco; reemplazar el nodo sí */
      const suma = li.querySelector('.cline__sum');
      if (suma) suma.textContent = precio(l.price * l.qty);
    });
    totalTxt.textContent = precio(API.total());
    itemsTxt.textContent = API.count();
    itemsTxt.hidden = !lineas.length;
    pintarContador();
  }

  function escapar(txt) {
    return String(txt).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  }

  /* ---------- 6) ABRIR / CERRAR (foco, Escape y scroll propios) ---------- */
  let ultimoFoco = null;

  function abrir() {
    if (!panel.hidden) return;
    ultimoFoco = document.activeElement;
    panel.hidden = false;
    void panel.offsetHeight;                 /* reflow: que la transición arranque de cerrado */
    panel.classList.add('is-open');
    document.documentElement.classList.add('carrito-abierto');   /* esconde la burbuja */
    document.body.style.overflow = 'hidden';
    const aspa = $('.cart__close');
    if (aspa) aspa.focus();
  }

  function cerrar() {
    if (panel.hidden) return;
    panel.classList.remove('is-open');
    document.documentElement.classList.remove('carrito-abierto');
    document.body.style.overflow = '';
    const ocultar = () => { panel.hidden = true; };
    $('.cart__panel').addEventListener('transitionend', ocultar, { once: true });
    setTimeout(ocultar, 500);                /* red de seguridad si no dispara transitionend */
    if (ultimoFoco && document.contains(ultimoFoco)) ultimoFoco.focus();
  }

  /* ---------- 7) ANIMACIONES ---------- */
  const quietud = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ¿A dónde tiene que llegar el vuelo? Al control de carrito que se esté VIENDO: la burbuja
     flotante si está en pantalla, y si no el icono del header. El último recurso (ninguno de los
     dos visible, algo raro) es la esquina superior derecha. */
  function destinoCarrito() {
    const visible = Array.from(document.querySelectorAll('[data-cart-open]')).find(el => {
      const r = el.getBoundingClientRect();
      return r.width && r.bottom > 4 && r.top < window.innerHeight - 4;
    });
    if (visible) {
      const r = visible.getBoundingClientRect();
      return { x: r.left + r.width / 2, y: r.top + r.height / 2, el: visible };
    }
    return { x: window.innerWidth - 46, y: 40, el: null };
  }

  /* El destino da un golpecito cuando el producto entra. Es lo que hace que se LEA como que llegó,
     en vez de que la imagen se esfume. Es distinto del contador que salta (que el dueño no quiso):
     acá reacciona el carrito, y sólo cuando algo aterriza. */
  function pulso(el) {
    if (!el || quietud() || typeof el.animate !== 'function') return;
    el.animate([
      { transform: 'scale(1)' },
      { transform: 'scale(.86)', offset: .32 },
      { transform: 'scale(1.12)', offset: .62 },
      { transform: 'scale(1)' }
    ], { duration: 420, easing: 'ease-out' });
  }

  /* El producto viaja hasta el carrito convertido en BURBUJA.
     Va con la Web Animations API y no con @keyframes porque el origen y el destino son coordenadas
     que el CSS no puede conocer.

     ⚠️ EL ARCO SE HACE CON DOS CAPAS, UNA POR EJE, y cada una con UNA SOLA curva de velocidad.
     La primera versión usaba una capa con cuatro fotogramas y una curva distinta por tramo, y eso
     hacía que la burbuja PARARA dos o tres veces en el camino: cada tramo terminaba frenando y el
     siguiente arrancaba de cero, así que la velocidad caía a casi nada en cada costura.
     Con un eje por capa no hay costuras: el envoltorio corre en X con su curva y la burbuja cae en
     Y con la suya. La suma de las dos ES el arco, y sale continuo.

       X (envoltorio): velocidad constante                 → linear
       Y (burbuja):    se sostiene y después se deja caer   → cubic-bezier(.6,0,.88,.44)

     ⚠️ La X va LINEAL a propósito, aunque suene raro. Se midió el perfil de velocidad del recorrido
     completo con cinco curvas distintas en X, y toda curva con "impulso de salida" hace que la
     velocidad se desplome en el medio, porque la X ya frenó y la Y todavía no aceleró:

       cubic-bezier(.3,.6,.35,1)   3096 → 806 → 1980 px/s   (mínima: 26% del pico)
       cubic-bezier(.2,.3,.5,1)    2409 → 1084 → 1983       (45%)
       linear                      1416 → … → 2434          (58%, y SIEMPRE subiendo)

     Con la X lineal la velocidad total no baja nunca: crece de principio a fin. Todo el carácter de
     "entra acelerando al carrito" lo pone la curva de la Y, que es la que se deja caer al final. */
  function volar(desdeImg) {
    if (!desdeImg || quietud() || typeof desdeImg.animate !== 'function') return;

    const origen = desdeImg.getBoundingClientRect();
    if (!origen.width) return;

    const destino = destinoCarrito();
    const lado = Math.min(origen.width, origen.height, 130);

    /* Capa de fuera: sólo se mueve en X. Se la centra sobre la foto y en cuadrado, para que la
       burbuja sea un círculo y no un óvalo. */
    const capa = document.createElement('div');
    capa.className = 'cart-fly';
    capa.style.left = (origen.left + (origen.width - lado) / 2) + 'px';
    capa.style.top = (origen.top + (origen.height - lado) / 2) + 'px';
    capa.style.width = lado + 'px';
    capa.style.height = lado + 'px';

    /* Capa de dentro: la burbuja. Ya es un círculo desde el primer fotograma (el redondeo está en
       el CSS, no se anima): así se lee como burbuja durante todo el viaje y no sólo al final. */
    const clon = desdeImg.cloneNode(true);
    clon.className = 'cart-fly__img';
    clon.removeAttribute('data-optional');
    clon.removeAttribute('width');
    clon.removeAttribute('height');
    capa.appendChild(clon);
    document.body.appendChild(capa);

    const dx = destino.x - (origen.left + origen.width / 2);
    const dy = destino.y - (origen.top + origen.height / 2);

    const enX = capa.animate(
      [{ transform: 'translateX(0)' },
       { transform: `translateX(${dx}px)` }],
      { duration: CONFIG.vueloMs, easing: 'linear', fill: 'forwards' });

    clon.animate(
      [{ transform: 'translateY(0) scale(1)', opacity: 1 },
       { transform: `translateY(${dy}px) scale(.12)`, opacity: .9 }],
      { duration: CONFIG.vueloMs, easing: 'cubic-bezier(.6,0,.88,.44)', fill: 'forwards' });

    /* El golpecito del destino arranca un pelo antes de que la burbuja llegue: si esperara al final
       exacto, se lee como dos cosas separadas en vez de un impacto. */
    setTimeout(() => pulso(destino.el), CONFIG.vueloMs - 90);

    /* ⚠️ Si la capa no se borra, cada click deja una imagen pegada al body para siempre */
    const limpiar = () => capa.remove();
    enX.addEventListener('finish', limpiar);
    enX.addEventListener('cancel', limpiar);
    setTimeout(limpiar, CONFIG.vueloMs + 800);
  }

  /* El botón confirma en el sitio: pasa un instante a "Added" y vuelve.
     Se le congela el ancho para que la tarjeta no dé un salto al cambiar el texto. */
  const confirmando = new WeakSet();

  function confirmar(boton) {
    if (confirmando.has(boton)) return;
    confirmando.add(boton);

    const tieneTexto = boton.textContent.trim().length > 0;
    const original = boton.innerHTML;
    if (tieneTexto) boton.style.width = boton.getBoundingClientRect().width + 'px';
    boton.classList.add('is-added');
    if (tieneTexto) boton.textContent = CONFIG.textos.agregado;

    setTimeout(() => {
      boton.classList.remove('is-added');
      if (tieneTexto) { boton.innerHTML = original; boton.style.width = ''; }
      confirmando.delete(boton);
    }, quietud() ? 250 : 1100);
  }

  /* ---------- 8) ESCUCHAS ----------
     Delegadas en el document, como el reproductor de TikTok y el selector de cantidad: así
     funcionan con las tarjetas que el filtro de la tienda esconde y muestra, y con las líneas del
     panel, que se crean después. */
  function cerca(e, sel) {
    return e.target && e.target.closest ? e.target.closest(sel) : null;
  }

  document.addEventListener('click', e => {

    /* abrir / cerrar */
    if (cerca(e, '[data-cart-open]')) { e.preventDefault(); abrir(); return; }
    if (cerca(e, '[data-cart-close]')) { cerrar(); return; }

    /* agregar desde una tarjeta */
    const boton = cerca(e, '[data-cart-add]');
    if (boton) {
      e.preventDefault();
      const tarjeta = boton.closest('[data-sku]');
      if (!tarjeta) return;                  /* sin contrato de datos no se agrega nada */

      /* La cantidad sale del selector de la propia tarjeta si lo tiene (tienda); si no, 1 */
      const campo = tarjeta.querySelector('[data-qty] .qty__num');
      const qty = campo ? parseInt(campo.value, 10) || 1 : 1;

      API.add(tarjeta.dataset, qty);
      volar(tarjeta.querySelector('img'));
      confirmar(boton);
      return;
    }

    /* líneas del panel: los −/+ de acá los maneja este archivo y no el [data-qty] de app.js,
       porque tienen que escribir en el estado del carrito, que app.js no conoce */
    const paso = cerca(e, '[data-cart-step]');
    if (paso) {
      const linea = paso.closest('[data-sku]');
      const actual = lineas.find(l => l.sku === linea.dataset.sku);
      if (actual) API.setQty(actual.sku, actual.qty + Number(paso.dataset.cartStep));
      return;
    }

    const borrar = cerca(e, '[data-cart-del]');
    if (borrar) {
      const linea = borrar.closest('[data-sku]');
      if (linea) API.remove(linea.dataset.sku);
      return;
    }

    /* Vaciar el carrito, en dos toques: el primero pide confirmación y el segundo vacía.
       Es destructivo y está al lado de "Continue shopping", así que un solo click es peligroso.
       Se usa esto y no confirm() para no meter un diálogo del navegador en medio del panel. */
    const vaciar = cerca(e, '[data-cart-clear]');
    if (vaciar) {
      if (vaciar.dataset.armado) {
        clearTimeout(+vaciar.dataset.armado);
        delete vaciar.dataset.armado;
        API.clear();
        return;
      }
      vaciar.textContent = T.vaciarOk;
      vaciar.classList.add('is-armado');
      vaciar.dataset.armado = setTimeout(() => {
        vaciar.textContent = T.vaciar;
        vaciar.classList.remove('is-armado');
        delete vaciar.dataset.armado;
      }, 3000);
    }
  });

  /* ---------- El número de cada línea, editable a mano ----------
     Mismas reglas que el selector de la tienda, y por el mismo motivo: type="text" con
     inputmode="numeric" en vez de type="number", para no pelearse con las flechitas del navegador
     ni permitir "e", "+" o ".". Acá el campo además escribe en el estado del carrito, que es algo
     que el selector de app.js no sabe hacer — de ahí que esté implementado aparte. */
  document.addEventListener('input', e => {
    const campo = cerca(e, '.cline__num');
    if (!campo) return;
    /* Sólo se filtran los caracteres que no son dígitos. NO se recorta ni se guarda todavía: hay
       que poder dejarlo vacío para escribir otro número, y guardar en cada tecla repintaría la
       lista a media palabra. */
    const limpio = campo.value.replace(/[^0-9]/g, '');
    if (limpio !== campo.value) campo.value = limpio;
  });

  document.addEventListener('focusout', e => {
    const campo = cerca(e, '.cline__num');
    if (!campo) return;
    /* Red de seguridad: si el campo ya salió del DOM, su valor es viejo y guardarlo desharía el
       cambio que provocó su salida. Con refrescarNumeros() esto ya no debería pasar, pero si
       mañana alguien vuelve a repintar la lista en un cambio de cantidad, no se rompe. */
    if (!campo.isConnected) return;
    const linea = campo.closest('[data-sku]');
    /* Vacío o 0 → se quita la línea, igual que bajar con el − desde 1 */
    API.setQty(linea.dataset.sku, parseInt(campo.value, 10) || 0);
  });

  document.addEventListener('keydown', e => {
    const campo = cerca(e, '.cline__num');
    if (!campo) return;
    const sku = campo.closest('[data-sku]').dataset.sku;
    const actual = parseInt(campo.value, 10) || 0;
    if (e.key === 'ArrowUp')   { e.preventDefault(); API.setQty(sku, actual + 1); }
    if (e.key === 'ArrowDown') { e.preventDefault(); API.setQty(sku, actual - 1); }
    if (e.key === 'Enter')     { e.preventDefault(); campo.blur(); }
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && !panel.hidden) cerrar();
  });

  /* Si hay dos pestañas abiertas, la otra se pone al día sola */
  window.addEventListener('storage', e => {
    if (e.key !== CONFIG.clave) return;
    lineas = leer();
    pintar();
  });

  /* ---------- 9) ARRANQUE ---------- */
  function montar() {
    document.body.appendChild(panel);
    document.body.appendChild(burbuja);

    /* La burbuja se muestra en cuanto el icono del header deja de verse.
       Se hace midiendo su posición en cada scroll (con rAF de por medio, así se mide una vez por
       fotograma como máximo) y no con IntersectionObserver, por dos razones: la regla queda
       explícita —"el icono salió por arriba"— en vez de depender de un umbral, y es un solo camino
       de código, más fácil de portar a la implementación real. */
    const iconoHeader = document.querySelector('[data-cart-open]:not(.cart-fab)');

    /* Se comprueba directo en el evento, SIN requestAnimationFrame de por medio. Los navegadores
       ya limitan `scroll` a un evento por fotograma, así que el rAF no ahorraba nada y sí escondía
       el problema: leer una sola caja por fotograma es barato. */
    function revisarBurbuja() {
      if (!iconoHeader) { burbuja.classList.toggle('is-on', API.count() > 0); return; }
      const r = iconoHeader.getBoundingClientRect();
      const seVe = r.bottom > 8 && r.top < window.innerHeight - 8;
      burbuja.classList.toggle('is-on', !seVe && API.count() > 0);
    }

    window.addEventListener('scroll', revisarBurbuja, { passive: true });
    window.addEventListener('resize', revisarBurbuja);
    revisarBurbuja();

    lista = $('[data-cart-list]');
    vacio = $('[data-cart-empty]');
    pie = $('[data-cart-foot]');
    totalTxt = $('[data-cart-total]');
    itemsTxt = $('[data-cart-total-items]');
    lineas = leer();
    pintar();
    sincronizar();     /* en Shopify la verdad la tiene el servidor: se pide y se repinta */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montar);
  } else {
    montar();
  }

  /* En el personalizador una sección repintada trae un icono de carrito NUEVO, sin el
     contador que inyecta pintarContador(). El panel y sus listeners no hacen falta
     rehacerlos: el panel vive fuera de las secciones y todo va delegado en el document. */
  document.addEventListener('shopify:section:load', function () { pintarContador(); });
})();

}
